export interface ItemsResponse {
	items: any;
	newId?: string;
}
